// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .contact-container {
            min-height: 100vh;
            padding: 2rem;
        }
        
        .contact-card {
            border-radius: 12px;
            box-shadow: 0 10px 30px rgba(0,0,0,0.1);
            overflow: hidden;
            border: none;
        }
        
        .form-section {
            padding: 3rem;
        }
        
        .contact-info-section {
            background: linear-gradient(135deg, #e3f2fd 0%, #f0f8ff 100%);
            padding: 3rem;
        }
        
        .form-control {
            border-radius: 8px;
            border: 1px solid #dee2e6;
            padding: 0.75rem 1rem;
            font-size: 0.95rem;
            transition: all 0.3s ease;
        }
        
        .form-control:focus {
            border-color: #0d6efd;
            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);
        }
        
        .form-control.is-invalid {
            border-color: #dc3545;
        }
        
        .btn-submit {
            background: linear-gradient(135deg, #0d6efd 0%, #0056b3 100%);
            border: none;
            padding: 0.75rem 2rem;
            border-radius: 8px;
            font-weight: 600;
            transition: all 0.3s ease;
        }
        
        .btn-submit:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);
        }
        
        .btn-submit:disabled {
            transform: none;
            box-shadow: none;
            opacity: 0.6;
        }
        
        .contact-info-item {
            margin-bottom: 2rem;
        }
        
        .contact-icon {
            width: 48px;
            height: 48px;
            background: linear-gradient(135deg, #0d6efd 0%, #0056b3 100%);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: white;
            font-size: 1.5rem;
        }
        
        .contact-title {
            font-size: 1.25rem;
            font-weight: 600;
            color: #212529;
            margin-bottom: 0.5rem;
        }
        
        .contact-text {
            color: #6c757d;
            line-height: 1.6;
        }
        
        .map-container {
            background: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 15px rgba(0,0,0,0.1);
        }
        
        .map-placeholder {
            height: 200px;
            background: linear-gradient(135deg, #a8e6cf 0%, #88d8c0 100%);
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .map-marker {
            position: absolute;
            background: #dc3545;
            color: white;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
        }
        
        .invalid-feedback {
            display: block;
        }
        
        .form-check-input:checked {
            background-color: #0d6efd;
            border-color: #0d6efd;
        }
        
        .spinner-border-sm {
            width: 1rem;
            height: 1rem;
        }
        
        @media (max-width: 768px) {
            .form-section, .contact-info-section {
                padding: 2rem;
            }
        }`, "",{"version":3,"sources":["webpack://./src/containers/ContactUs/ContactUs.css"],"names":[],"mappings":"CAAC;YACW,iBAAiB;YACjB,aAAa;QACjB;;QAEA;YACI,mBAAmB;YACnB,uCAAuC;YACvC,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,aAAa;QACjB;;QAEA;YACI,6DAA6D;YAC7D,aAAa;QACjB;;QAEA;YACI,kBAAkB;YAClB,yBAAyB;YACzB,qBAAqB;YACrB,kBAAkB;YAClB,yBAAyB;QAC7B;;QAEA;YACI,qBAAqB;YACrB,iDAAiD;QACrD;;QAEA;YACI,qBAAqB;QACzB;;QAEA;YACI,6DAA6D;YAC7D,YAAY;YACZ,qBAAqB;YACrB,kBAAkB;YAClB,gBAAgB;YAChB,yBAAyB;QAC7B;;QAEA;YACI,2BAA2B;YAC3B,8CAA8C;QAClD;;QAEA;YACI,eAAe;YACf,gBAAgB;YAChB,YAAY;QAChB;;QAEA;YACI,mBAAmB;QACvB;;QAEA;YACI,WAAW;YACX,YAAY;YACZ,6DAA6D;YAC7D,mBAAmB;YACnB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,YAAY;YACZ,iBAAiB;QACrB;;QAEA;YACI,kBAAkB;YAClB,gBAAgB;YAChB,cAAc;YACd,qBAAqB;QACzB;;QAEA;YACI,cAAc;YACd,gBAAgB;QACpB;;QAEA;YACI,iBAAiB;YACjB,mBAAmB;YACnB,gBAAgB;YAChB,sCAAsC;QAC1C;;QAEA;YACI,aAAa;YACb,6DAA6D;YAC7D,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;QAC3B;;QAEA;YACI,kBAAkB;YAClB,mBAAmB;YACnB,YAAY;YACZ,WAAW;YACX,YAAY;YACZ,kBAAkB;YAClB,aAAa;YACb,mBAAmB;YACnB,uBAAuB;YACvB,eAAe;QACnB;;QAEA;YACI,cAAc;QAClB;;QAEA;YACI,yBAAyB;YACzB,qBAAqB;QACzB;;QAEA;YACI,WAAW;YACX,YAAY;QAChB;;QAEA;YACI;gBACI,aAAa;YACjB;QACJ","sourcesContent":[" .contact-container {\n            min-height: 100vh;\n            padding: 2rem;\n        }\n        \n        .contact-card {\n            border-radius: 12px;\n            box-shadow: 0 10px 30px rgba(0,0,0,0.1);\n            overflow: hidden;\n            border: none;\n        }\n        \n        .form-section {\n            padding: 3rem;\n        }\n        \n        .contact-info-section {\n            background: linear-gradient(135deg, #e3f2fd 0%, #f0f8ff 100%);\n            padding: 3rem;\n        }\n        \n        .form-control {\n            border-radius: 8px;\n            border: 1px solid #dee2e6;\n            padding: 0.75rem 1rem;\n            font-size: 0.95rem;\n            transition: all 0.3s ease;\n        }\n        \n        .form-control:focus {\n            border-color: #0d6efd;\n            box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.25);\n        }\n        \n        .form-control.is-invalid {\n            border-color: #dc3545;\n        }\n        \n        .btn-submit {\n            background: linear-gradient(135deg, #0d6efd 0%, #0056b3 100%);\n            border: none;\n            padding: 0.75rem 2rem;\n            border-radius: 8px;\n            font-weight: 600;\n            transition: all 0.3s ease;\n        }\n        \n        .btn-submit:hover {\n            transform: translateY(-2px);\n            box-shadow: 0 5px 15px rgba(13, 110, 253, 0.3);\n        }\n        \n        .btn-submit:disabled {\n            transform: none;\n            box-shadow: none;\n            opacity: 0.6;\n        }\n        \n        .contact-info-item {\n            margin-bottom: 2rem;\n        }\n        \n        .contact-icon {\n            width: 48px;\n            height: 48px;\n            background: linear-gradient(135deg, #0d6efd 0%, #0056b3 100%);\n            border-radius: 12px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: white;\n            font-size: 1.5rem;\n        }\n        \n        .contact-title {\n            font-size: 1.25rem;\n            font-weight: 600;\n            color: #212529;\n            margin-bottom: 0.5rem;\n        }\n        \n        .contact-text {\n            color: #6c757d;\n            line-height: 1.6;\n        }\n        \n        .map-container {\n            background: white;\n            border-radius: 12px;\n            overflow: hidden;\n            box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n        }\n        \n        .map-placeholder {\n            height: 200px;\n            background: linear-gradient(135deg, #a8e6cf 0%, #88d8c0 100%);\n            position: relative;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n        \n        .map-marker {\n            position: absolute;\n            background: #dc3545;\n            color: white;\n            width: 32px;\n            height: 32px;\n            border-radius: 50%;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 1rem;\n        }\n        \n        .invalid-feedback {\n            display: block;\n        }\n        \n        .form-check-input:checked {\n            background-color: #0d6efd;\n            border-color: #0d6efd;\n        }\n        \n        .spinner-border-sm {\n            width: 1rem;\n            height: 1rem;\n        }\n        \n        @media (max-width: 768px) {\n            .form-section, .contact-info-section {\n                padding: 2rem;\n            }\n        }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
